import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop,
  TextField,
  Button,
  Typography,
} from 'rmwc';
import { claimGuestUser } from '../actions/userActions';
import { Text } from './Text';
import { logEvent } from '../helpers/analytics';
import { wlVar } from '../helpers/whitelabel';

export const RegistrationDialog = connect()(
  class extends Component {
    state = { email: '', password: '', first_name: '', last_name: '', phone: '' };

    onSave = () => {
      const { first_name, last_name, email, phone, password } = this.state;
      const { dispatch, onAccept } = this.props;

      dispatch(claimGuestUser(first_name, last_name, email, phone, password)).then(onAccept);
    };

    onChange = event => {
      this.setState({
        [event.target.name]: event.target.value,
      });
    };

    canContinue = () => {
      const { first_name, last_name, email, password } = this.state;

      const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (this.props.variant !== 'BEFORE_YOU_LEAVE') {
        return email && re.test(email) && password && password.length >= 6 && first_name && first_name.length >= 1;
      } else {
        return email && re.test(email);
      }
    };

    nameField = () => (
      <div className="row">
        <div className="col-6">
          <TextField
            className="hrbr-input-wide"
            name="first_name"
            type="text"
            value={this.state.first_name}
            label="First Name"
            onChange={this.onChange}
          />
        </div>
        <div className="col-6">
          <TextField
            className="hrbr-input-wide"
            name="last_name"
            type="text"
            value={this.state.last_name}
            label="Last Name"
            onChange={this.onChange}
          />
        </div>
      </div>
    );

    phoneField = () => (
      <TextField
        className="hrbr-input-wide"
        type="text"
        name="phone"
        value={this.state.phone}
        label="Phone Number"
        onChange={this.onChange}
      />
    );

    emailField = () => (
      <TextField
        className="hrbr-input-wide"
        type="text"
        name="email"
        value={this.state.email}
        label="E-mail Address"
        onChange={this.onChange}
      />
    );

    passwordField = () => (
      <TextField
        className="hrbr-input-wide"
        type="password"
        name="password"
        label="Password"
        value={this.state.password}
        onChange={this.onChange}
      />
    );

    variantCopy = {
      BEFORE_YOU_LEAVE: {
        title: "Don't leave empty-handed",
        submitButton: 'Save my Progress',
        cancelButton: 'Cancel',
      },
      SAVE_AND_REVISIT: {
        title: 'Save and Revisit',
        submitButton: 'Save my Progress',
        cancelButton: 'Skip for now',
      },
      HEADER_REGISTER: {
        title: 'Register for Harbor',
        submitButton: 'Register for Free',
        cancelButton: 'Cancel',
      },
      REQUIRED_REGISTER: {
        title: 'Register to Review Plan',
        submitButton: 'See my Plan',
        cancelButton: "I don't want my plan",
      },
      ONBOARDING_REGISTER: {
        title: 'Register to Review Plan',
        submitButton: 'See my Plan',
        cancelButton: "I don't want my plan",
      },
    };

    render() {
      const { variant } = this.props;
      let title,
        submitButton,
        cancelButton = '';
      if (variant != null) {
        title = this.variantCopy[variant].title;
        submitButton = this.variantCopy[variant].submitButton;
        cancelButton = this.variantCopy[variant].cancelButton;
      }

      return (
        <Dialog open={this.props.open} onAccept={this.onSave} onCancel={this.props.onCancel}>
          <DialogSurface className="hrbr-dialog-small">
            <DialogHeader>
              <DialogHeaderTitle>{title}</DialogHeaderTitle>
            </DialogHeader>
            <DialogBody>
              {variant == 'BEFORE_YOU_LEAVE' && (
                <Fragment>
                  <Typography tag="div" use="body1">
                    Stay in touch and get updates on finacial advice tailored to your needs.
                  </Typography>
                  {this.nameField()}
                  {wlVar('asks_for_phone_number') && this.phoneField()}
                  {this.emailField()}
                </Fragment>
              )}
              {variant == 'SAVE_AND_REVISIT' && (
                <Fragment>
                  <Typography tag="div" use="body1">
                    You're almost there! Save your progress so you can pick up right where you left off.
                  </Typography>
                  {this.nameField()}
                  {wlVar('asks_for_phone_number') && this.phoneField()}
                  {this.emailField()}
                  {this.passwordField()}
                </Fragment>
              )}
              {variant == 'HEADER_REGISTER' && (
                <Fragment>
                  <Typography tag="div" use="body1">
                    Your free account allows you to save and revisit your plan, and to access our advanced planning
                    features.
                  </Typography>
                  {this.nameField()}
                  {this.emailField()}
                  {this.passwordField()}
                  <Typography tag="div" className="mt-2" use="caption">
                    Learn more about our free{' '}
                    <a target="_blank" href="https://www.harborplan.com/our-services">
                      Planning Essentials
                    </a>{' '}
                    services.
                  </Typography>
                </Fragment>
              )}
              {variant == 'REQUIRED_REGISTER' && (
                <Fragment>
                  <Text use="body1">
                    Please register for a free account to access our advanced planning features and save your progress.
                  </Text>
                  {this.nameField()}
                  {this.emailField()}
                  {this.passwordField()}
                </Fragment>
              )}
            </DialogBody>
            <DialogFooter>
              <DialogFooterButton cancel>{cancelButton}</DialogFooterButton>
              <DialogFooterButton accept raised disabled={!this.canContinue()}>
                {submitButton}
              </DialogFooterButton>
            </DialogFooter>
          </DialogSurface>
          <DialogBackdrop />
        </Dialog>
      );
    }
  }
);

export function withRegistrationDialog(WrappedComponent) {
  return class extends Component {
    state = { open: false, variant: null };

    onOpen = (afterAccept, afterClose, variant) => {
      logEvent('RegistrationOpened', {
        variant: variant,
      });
      this.setState({ open: true, variant, afterClose, afterAccept });
    };

    onCancel = () => {
      logEvent('RegistrationCancelled', {
        variant: this.state.variant,
      });
      this.setState({ open: false }, this.state.afterClose);
    };

    onAccept = () => {
      logEvent('RegistrationAccepted', {
        variant: this.state.variant,
      });
      this.setState({ open: false }, this.state.afterAccept);
    };

    withRegistrationGuard = (user, action) => {
      return () => {
        if (user.is_guest) {
          this.onOpen(action, () => {}, 'REQUIRED_REGISTER');
        } else {
          action();
        }
      };
    };

    render() {
      return (
        <div>
          <WrappedComponent
            openRegistrationDialog={this.onOpen}
            withRegistrationGuard={this.withRegistrationGuard}
            {...this.props}
          />
          <RegistrationDialog
            open={this.state.open}
            variant={this.state.variant}
            onCancel={this.onCancel}
            onAccept={this.onAccept}
          />
        </div>
      );
    }
  };
}
